import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CustomerIdentifiersQueryQuery,
  CustomerIdentifiersQueryQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { configurableTypeFragment } from "src/graphql/anti-fraud/fragments/ConfigurableType";
import { useFetchQuery } from "src/graphql/utils";
import { mapDataTypeToAppDataType } from "src/mappers/typedValue.mappers";
import { ClientSchemaIdentifier } from "src/types/clientSchema";

export const customerIdentifiersQuery = gql/* GraphQL */ `
  query CustomerIdentifiersQuery {
    schema {
      customerType {
        ...ConfigurableTypeFragment
      }
    }
  }
  ${configurableTypeFragment}
` as TypedDocumentNode<CustomerIdentifiersQueryQuery, CustomerIdentifiersQueryQueryVariables>;

export const useGetCustomerIdentifiersQuery = ({
  onError,
  skip,
}: {
  onError: (error: Error) => void;
  skip?: boolean;
}) => {
  return useFetchQuery(customerIdentifiersQuery, {
    toData: (data) => [
      ...(data?.schema?.customerType?.elements?.flatMap((element) =>
        element.elementType.identifiers.map(
          (identifier) =>
            ({
              elementCode: element.code,
              elementName: element.name,
              identifierCode: identifier.code,
              identifierTypeCode: identifier.identifierType.code,
              identifierName: identifier.name,
              dataType: mapDataTypeToAppDataType(identifier.sourceProperties[0].datatype),
              clientType: "customer",
            } satisfies ClientSchemaIdentifier)
        )
      ) ?? []),
    ],
    isEmpty: (data) => !data?.schema?.customerType,
    queryOptions: { onError, skip },
    uiErrors: {
      fetchError: "FETCH-IDENTIFIER-TYPES-ERROR",
      emptyError: "EMPTY-IDENTIFIER-TYPES-ERROR",
    },
  });
};
